/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v4-mini";
import { safeParse } from "../../lib/schemas.js";
import { Result as SafeParseResult } from "../../types/fp.js";
import { SDKValidationError } from "../errors/sdkvalidationerror.js";
import {
  SyncedAgentUser,
  SyncedAgentUser$inboundSchema,
} from "./syncedagentuser.js";

export type ListSyncedUsersResult = {
  /**
   * Emails seen syncing the device agent, most recently active first.
   */
  users: Array<SyncedAgentUser>;
};

/** @internal */
export const ListSyncedUsersResult$inboundSchema: z.ZodMiniType<
  ListSyncedUsersResult,
  unknown
> = z.object({
  users: z.array(SyncedAgentUser$inboundSchema),
});

export function listSyncedUsersResultFromJSON(
  jsonString: string,
): SafeParseResult<ListSyncedUsersResult, SDKValidationError> {
  return safeParse(
    jsonString,
    (x) => ListSyncedUsersResult$inboundSchema.parse(JSON.parse(x)),
    `Failed to parse 'ListSyncedUsersResult' from JSON`,
  );
}
